import { DocumentUtilities } from '@pwc/pwc-deals-web-common';
import resetCalculationDataForDocument from '../actions/resetCalculationDataForDocument';

const resetAllCalculationDataByDocumentCode = (
  projectId,
  documentCode,
  dispatch
) => {
  const documentWithDependencies =
    DocumentUtilities.getDocumentWithDependencies(documentCode);
  const documentsForRefresh = [
    documentWithDependencies.document,
    ...documentWithDependencies.dependencies,
  ];
  documentsForRefresh.forEach((code) => {
    dispatch(resetCalculationDataForDocument(code));
  });
};

/**
 * WARNING - due to factCalculations be wary of dispatching this outside of
 * transformAllIngestedStructuredDocumentsThunk
 */
export const resetCalculationDataByDocumentCodesThunk =
  (projectId, documentCodes = []) =>
  async (dispatch) => {
    documentCodes.forEach((documentCode) => {
      resetAllCalculationDataByDocumentCode(projectId, documentCode, dispatch);
    });
  };
